module.exports = __webpack_public_path__ + "static/media/Close.9eafc42f.svg";